// extracted by mini-css-extract-plugin
export default {"recipientDetails":"RecipientDetails_recipientDetails__lXJ58","row":"RecipientDetails_row__IuZZD","label":"RecipientDetails_label__u3LC3"};